import type { FaireProductEntity } from "../../entity_types/product";

export const p_96epngnfe8: FaireProductEntity = {
  token: "p_96epngnfe8",
  type: "product",
  name: "18K Gold Black Onyx/Green Jade Gemstone Pendant Necklace",
  brandToken: "b_n2jsjnhwd3",
  brandName: "Furano Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/2178b068681967177fcaf9cf62e066e87d0424d6d40d6e7b5f2bebff083738bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b18d9f8c1b5d2cc94909e54dc96249f75894b64213ad22e3d36dd72634e5d71.jpeg",
    "https://cdn.faire.com/fastly/4c42f0993446c21efe4238d0c19673d2275a1f4df3baeb2f4671f9755f22a781.jpeg",
    "https://cdn.faire.com/fastly/71a9a8f2943f42f89f75b98a1cb2ec25027e7769b5ab39637488878ad086a021.jpeg",
    "https://cdn.faire.com/fastly/6f22d06ca27282b9f5def95c151d91b431e8344326d0b3285d24de4c135274ce.jpeg",
  ],
  priceDollars: 10.99,
  description:
    "• Nature Black Onyx\n• Our jewelry is crafted with 18K Gold Plating on stainless steel for durability and elegance.\n\n• It is generally waterproof and can resist tarnishing for up to a year with regular wear.\n\n• We offer white labeling options, and all jewelry is shipped in basic plain plastic pouches.\n\n• Additionally, paper cards and gift boxes featuring our logos are available. Please message us if you would like to buy.\n\n• Based in Los Angeles, we ensure fast shipping, with orders processed within one to two business days.",
  tags: [],
  msrpDollars: 48.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:47.888Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
